export default "/_next/static/sounds/PAPER_SHREDDER-373aaebdcd165913d3e49eea54486a75.mp3";